import React from "react";
import "./AssistantHeader.scss";
import axios from "axios";
import ImageDefault from "../ImageHandler/ImageDefault.js";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import Utils from "../../utils";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
const AssistantHeader = ({ assistantDetail }) => {
  const token = Utils.getLocalStorageItem("_t");

  const navigate = useNavigate();
  const fetchDataTable = async (id) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API}/genai/assistantVersion`,
        { uuid: id },
        {
          headers: {
            "X-Access-Token": token,
          },
        }
      );
      if (!_.isEmpty(response)) {
        navigate(`/dashboard/mainDashboard/${response.data?.data?.draftUuid}`);
      }
    } catch (error) {
      navigate(`/dashboard/mainDashboard/${id}`);
    }
  };
  const handleEdit = (assistant) => {
    fetchDataTable(assistant);
  };
  return (
    <>
      <section className="assist-head-info card-section">
        <div className="img-head-wrap">
          <ImageDefault imageUrl={assistantDetail?.assistantImage} />
          {/* <svg
            className="card-section-img"
            xmlns="http://www.w3.org/2000/svg"
            width="140"
            height="140"
            viewBox="0 0 140 140"
            fill="none"
          >
            <g clip-path="url(#clip0_195_5231)">
              <path
                d="M70 140C108.66 140 140 108.66 140 70C140 31.3401 108.66 0 70 0C31.3401 0 0 31.3401 0 70C0 108.66 31.3401 140 70 140Z"
                fill="#B26F28"
              />
              <path
                d="M139.279 80.1424L108.674 49.5371L33.8506 97.1352L76.4456 139.73C108.719 136.755 134.681 111.92 139.279 80.1424Z"
                fill="#5D3B17"
              />
              <path
                d="M108.673 49.5352H33.8506V97.1332H108.673V49.5352Z"
                fill="#F7C600"
              />
              <path
                d="M33.8506 49.5369H108.674L71.262 26.5039L33.8506 49.5369Z"
                fill="#FFD630"
              />
              <path
                d="M44.5336 40.9727H98.0363C100.831 40.9727 103.085 43.2263 103.085 46.0209V97.1348H39.4849V46.0211C39.4849 43.2266 41.7388 40.9727 44.5336 40.9727Z"
                fill="white"
              />
              <path
                d="M33.8506 49.5371L70.4505 73.3363L33.8506 97.1355V49.5371Z"
                fill="#FFD630"
              />
              <path
                d="M33.8506 97.1353H108.674L71.2623 73.291L33.8506 97.1353Z"
                fill="#F5BE18"
              />
              <path
                d="M108.673 49.5371L72.0732 73.3363L108.673 97.1355V49.5371Z"
                fill="#FFD630"
              />
              <path
                d="M53.1875 47.0566H89.3819V50.0314H53.1875V47.0566ZM53.1875 57.4237H89.3819V60.3985H53.1875V57.4237ZM53.1875 52.2402H89.3819V55.2149H53.1875V52.2402Z"
                fill="#999999"
              />
            </g>
            <defs>
              <clipPath id="clip0_195_5231">
                <rect width="140" height="140" fill="white" />
              </clipPath>
            </defs>
          </svg> */}
        </div>
        <div className="card-right-section">
          <div className="card-right-section-header">
            <span className="card-heading">
              <strong>{assistantDetail?.assistantName}</strong>
            </span>
          </div>
          <div className="card-right-section-body">
            <p>{assistantDetail?.assistantDescription}</p>
          </div>
          <OverlayTrigger
            overlay={<Tooltip id="tooltip-disabled">Modify</Tooltip>}
          >
            <button
              type="button"
              class="bg-transparent btn-circle"
              onClick={() => handleEdit(assistantDetail?.uuid)}
            >
              <svg
                xmlns="
http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
                fill="rgba(65,134,189,1)"
              >
                <path d="M5 18.89H6.41421L15.7279 9.57627L14.3137 8.16206L5 17.4758V18.89ZM21 20.89H3V16.6473L16.435 3.21231C16.8256 2.82179 17.4587 2.82179 17.8492 3.21231L20.6777 6.04074C21.0682 6.43126 21.0682 7.06443 20.6777 7.45495L9.24264 18.89H21V20.89ZM15.7279 6.74785L17.1421 8.16206L18.5563 6.74785L17.1421 5.33363L15.7279 6.74785Z"></path>
              </svg>
            </button>
          </OverlayTrigger>

          {/* <div className="card-right-section-footer">
              <span className="footer-rating">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M16.1038 14.308L19.7403 11.183L21.9614 11.3753L17.8883 14.9022L19.0922 20.183L17.2057 19.0368L16.1038 14.308ZM13.9749 7.71L12.9634 5.33692L13.8153 3.2793L15.7595 7.8773L13.9749 7.71ZM7.34997 16.8253L10.5 14.9253L13.65 16.8503L12.825 13.2503L15.6 10.8503L11.95 10.5253L10.5 7.12535L9.04997 10.5003L5.39997 10.8253L8.17497 13.2503L7.34997 16.8253ZM5.07502 19.9618L6.50769 13.7926L1.72119 9.6446L8.03654 9.09655L10.5 3.2793L12.9634 9.09655L19.2787 9.6446L14.4922 13.7926L15.9249 19.9618L10.5 16.6888L5.07502 19.9618Z"
                    fill="#4186BD"
                  />
                </svg>
                4.7 / 5
              </span>
              <span className="footer-comments">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M7.11543 17.1153C6.86478 17.1153 6.65468 17.0305 6.48513 16.861C6.31558 16.6914 6.23081 16.4813 6.23081 16.2307V14.7307H18.6058L18.9231 15.0481V5.99998H20.4231C20.6737 5.99998 20.8838 6.08475 21.0534 6.2543C21.2229 6.42385 21.3077 6.63394 21.3077 6.88457V20.6537L17.7693 17.1153H7.11543ZM2.69238 16.2691V3.38463C2.69238 3.13398 2.77716 2.92388 2.94671 2.75433C3.11626 2.58478 3.32636 2.5 3.57701 2.5H16.0385C16.2891 2.5 16.4992 2.58478 16.6688 2.75433C16.8383 2.92388 16.9231 3.13398 16.9231 3.38463V11.8461C16.9231 12.0968 16.8383 12.3069 16.6688 12.4764C16.4992 12.646 16.2891 12.7307 16.0385 12.7307H6.23081L2.69238 16.2691ZM15.4231 11.2308V3.99998H4.19236V11.9231L4.88471 11.2308H15.4231Z" fill="#4186BD"/>
                </svg>
                176 comments
              </span>
              <span  className="footer-instruction">
                  Powered by ChatGPT4
              </span>
            </div> */}
        </div>
      </section>
    </>
  );
};

export default AssistantHeader;
